module.exports = __webpack_public_path__ + "images/logo.png?f84456296d88bce04b0904bd14873a56";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 50
// module chunks = 0